const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-no-script'] = {
        c: () => require('partner/modules/dobbies-no-script/dobbies-no-script.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-no-script',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-no-script'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };